import { watch, computed, unref } from 'vue';
import { useRoute } from 'vue-router';
import { useStructuredData } from '@/composables/useStructuredData';
import { agenciaStoreModule } from '@/store_pinia/agencia';

export function usePageMeta(options = {}) {
  const route = useRoute();
  const agenciaStore = agenciaStoreModule();
  const { createWebPageSchema, createBreadcrumbsFromRoute } = useStructuredData();

  const pageTitle = computed(() => unref(options.title) || route.meta?.title || '');
  const pageDescription = computed(() => unref(options.description) || route.meta?.description || '');
  const fullTitle = computed(() => `${pageTitle.value} | ${agenciaStore.getMetaTitulo}`);

  const updateMetaTags = () => {
    document.title = fullTitle.value;

    let descMeta = document.querySelector('meta[name="description"]');
    if (!descMeta) {
      descMeta = document.createElement('meta');
      descMeta.name = 'description';
      document.head.appendChild(descMeta);
    }
    descMeta.content = pageDescription.value;

    let ogTitleMeta = document.querySelector('meta[property="og:title"]');
    if (!ogTitleMeta) {
      ogTitleMeta = document.createElement('meta');
      ogTitleMeta.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitleMeta);
    }
    ogTitleMeta.content = fullTitle.value;

    let ogDescMeta = document.querySelector('meta[property="og:description"]');
    if (!ogDescMeta) {
      ogDescMeta = document.createElement('meta');
      ogDescMeta.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescMeta);
    }
    ogDescMeta.content = pageDescription.value;
  };

  const webPageSchema = computed(() =>
    createWebPageSchema({
      title: fullTitle.value,
      description: pageDescription.value,
      breadcrumbs: unref(options.breadcrumbs) || createBreadcrumbsFromRoute(),
      dateModified: unref(options.dateModified),
      image: unref(options.image),
    })
  );

  watch([pageTitle, pageDescription], updateMetaTags, { immediate: true });

  return {
    pageTitle,
    pageDescription,
    fullTitle,
    webPageSchema,
    updateMetaTags,
  };
}
